export const
    PRODUCT_CHANGE_SELECTED_ROW = "PRODUCT_CHANGE_SELECTED_ROW",
    PRODUCT_CHANGE_TABLE_PAGE = "PRODUCT_CHANGE_TABLE_PAGE",
    PRODUCT_CHANGE_TEXT_FOR_SEARCHING = "PRODUCT_CHANGE_TEXT_FOR_SEARCHING",
    PRODUCT_SEARCH_PRODUCTS_BY_TEXT_FAILURE = "PRODUCT_SEARCH_PRODUCTS_BY_TEXT_FAILURE",
    PRODUCT_SEARCH_PRODUCTS_BY_TEXT_REQUEST = "PRODUCT_SEARCH_PRODUCTS_BY_TEXT_REQUEST",
    PRODUCT_SEARCH_PRODUCTS_BY_TEXT_SUCCESS = "PRODUCT_SEARCH_PRODUCTS_BY_TEXT_SUCCESS",
    PRODUCT_SET_TO_INITIAL_STATE = "PRODUCT_SET_TO_INITIAL_STATE",
    PRODUCT_CONFIRM_MODAL = "PRODUCT_CONFIRM_MODAL";



// WEBPACK FOOTER //
// ./src/types/Products.js